import { render, staticRenderFns } from "./CatalogAddItem.vue?vue&type=template&id=64cf91fe&scoped=true&"
import script from "./CatalogAddItem.vue?vue&type=script&lang=ts&"
export * from "./CatalogAddItem.vue?vue&type=script&lang=ts&"
import style0 from "./CatalogAddItem.vue?vue&type=style&index=0&id=64cf91fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cf91fe",
  null
  
)

export default component.exports